import * as React from 'react';
import { mg } from './mg/mg';

function fixChromeEvents() {
	// https://github.com/facebook/react/issues/14856#issuecomment-479207136
	const EVENTS_TO_MODIFY = ['touchstart', 'touchmove', 'touchend', 'touchcancel', 'wheel'];

	// @ts-ignore
	const originalAddEventListener = document.addEventListener.bind();
	document.addEventListener = (...args: Array<any>) => {
		let [type, listener, options] = args;
		if (EVENTS_TO_MODIFY.includes(type)) {
			if (typeof options === 'boolean') {
				options = {
					capture: options,
					passive: false,
				};
			} else if (typeof options === 'object') {
				options = {
					...options,
					passive: false,
				};
			}
		}
		args[2] = options;
		// @ts-ignore
		return originalAddEventListener(...args);
	};

	// @ts-ignore
	const originalRemoveEventListener = document.removeEventListener.bind();
	document.removeEventListener = (type, listener, options) => {
		let modOptions = options;
		if (EVENTS_TO_MODIFY.includes(type)) {
			if (typeof options === 'boolean') {
				modOptions = {
					capture: options,
					passive: false,
				};
			} else if (typeof options === 'object') {
				modOptions = {
					...options,
					passive: false,
				};
			}
		}
		return originalRemoveEventListener(type, listener, modOptions);
	};
}

function getScrollPixels(event: React.WheelEvent) : number {
	// https://stackoverflow.com/questions/20110224/what-is-the-height-of-a-line-in-a-wheel-event-deltamode-dom-delta-line
	const e = event.nativeEvent as any;
	//console.log(event.deltaMode, event.deltaY, '---', e.wheelDelta, e.detail);
	if (event.deltaMode == 0) return event.deltaY; // DOM_DELTA_PIXEL, chrome
	if (event.deltaMode == 1) return 40 * event.deltaY; // DOM_DELTA_LINE, firefox
	if (e.wheelDelta) return -e.wheelDelta;
	if (e.detail) return 40 * e.detail;
	return event.deltaY;
}

function getScrollSteps(event: React.WheelEvent, stepSize: number) : number {
	mg.assert(stepSize > 0);
	const n = getScrollPixels(event) / stepSize;
	if (n>0 && n<1) return 1;
	if (n<0 && n>-1) return -1;
	return n;
}

export const Workarounds = {fixChromeEvents, getScrollSteps};
